import { createFileRoute, redirect } from '@tanstack/react-router';

import { LoginForm } from '@/features/auth/LoginForm';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().accessToken) {
      throw redirect({ to: '/' });
    }
  },
  component: LoginForm,
});
